
export default {
  name: "ExampleText",
};
